import moment from 'moment-timezone';

export const getDifferentTimezone = (timezone: string) => {
  const timezoneDiff = moment.tz(timezone).utcOffset();
  return timezoneDiff * 60000;
};

export const currentTimezone = moment.tz.guess();
